export default __webpack_public_path__ + "static/media/marker-gray-sky.256e9521.png";